// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../fragments/commonFragments.generated';
export type ProductOfferingConfigUtils_ReadyPlanOptionFragment = { __typename?: 'ReadyPlanOption', displayName: string, order: number, active: boolean, id: string, name: string, optionConflicts: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }>, optionConflictChildren: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }>, optionPrerequisites: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string } }>, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, required: boolean, isSingleOptionGroup: boolean, active: boolean, order: number, step?: { __typename?: 'CheckoutConfigOptionGroupStepDetail', code: Types.CheckoutConfigOptionGroupStep, name: string } | null | undefined } };

export type ProductOfferingConfigUtils_ReadyPlanOptionGroupFragment = { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, required: boolean, isSingleOptionGroup: boolean, active: boolean, order: number, step?: { __typename?: 'CheckoutConfigOptionGroupStepDetail', code: Types.CheckoutConfigOptionGroupStep, name: string } | null | undefined };

export const ProductOfferingConfigUtils_ReadyPlanOptionGroupFragmentDoc = gql`
    fragment ProductOfferingConfigUtils_ReadyPlanOptionGroup on ReadyPlanOptionGroup {
  id
  name
  required
  isSingleOptionGroup
  active
  order
  step {
    code
    name
  }
}
    `;
export const ProductOfferingConfigUtils_ReadyPlanOptionFragmentDoc = gql`
    fragment ProductOfferingConfigUtils_ReadyPlanOption on ReadyPlanOption {
  ...Named
  displayName
  order
  active
  optionConflicts {
    ...DisplayNamed
  }
  optionConflictChildren {
    ...DisplayNamed
  }
  optionPrerequisites {
    ...DisplayNamed
    optionGroup {
      id
    }
  }
  optionGroup {
    ...ProductOfferingConfigUtils_ReadyPlanOptionGroup
  }
}
    ${NamedFragmentDoc}
${DisplayNamedFragmentDoc}
${ProductOfferingConfigUtils_ReadyPlanOptionGroupFragmentDoc}`;